import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import slideVerify from "vue-monoplasty-slide-verify";
import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import api from './api/index.js'
import liveapi from './api/liveapi.js'
import axios from 'axios'
import scroll from 'vue-seamless-scroll'
import VueClipboard from 'vue-clipboard2'
import SlsTracker from '@aliyun-sls/web-track-browser'

const tracker = new SlsTracker({
  host: 'cn-shanghai.log.aliyuncs.com',      // 必填，例如 cn-hangzhou.log.aliyuncs.com
  project: 'jy-web-log', // 必填，SLS Project 名称
  logstore: 'web-log', // 必填，SLS Logstore 名称
  time: 10,                   // 可选，发送间隔（秒），默认 10 秒
  count: 10,                  // 可选，累计数量阈值，默认 10 条
});
Vue.prototype.$tracker = tracker;
Vue.prototype.$api = api
Vue.prototype.$liveapi = liveapi
Vue.prototype.bus = new Vue()
Vue.use(ElementUI);
Vue.use(VueClipboard)
Vue.use(scroll)
Vue.prototype.axios = axios;
Vue.config.productionTip = false
// Vue.use(slideVerify);
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
Vue.prototype.$store = store

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
}).$mount('#app')
